import * as React from "react"

function ShopperSentimentAnalysis(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 350" {...props}>
      <style>
        {
          ".shopper-sentiment-analysis_st3{fill:#fff}.shopper-sentiment-analysis_st4{fill:#e9ecef}.shopper-sentiment-analysis_st5{fill:#c1c6cb}.shopper-sentiment-analysis_st6{fill:#1eca8a}.shopper-sentiment-analysis_st7{fill:#00aeef}.shopper-sentiment-analysis_st8{fill:#f93b3b}"
        }
      </style>
      <g id="shopper-sentiment-analysis_Guides_and_Back">
        <path
          d="M577.3 240.6c-21.7 34.5-58.9 50.7-204.6 72.3-141.7 21-213.4 31-259.3 6.5-12.3-6.6-96.3-51.4-101-138.1-3.5-64.7 38.3-128.4 91.8-149 56-21.6 85.6 19.4 209.2 53.9 160.6 44.9 254 15.9 278.2 71 15.6 35.7-10.5 77.3-14.3 83.4z"
          fill="#7c8bdf"
        />
        <path className="shopper-sentiment-analysis_st3" d="M50 50h500v250H50z" />
      </g>
      <g id="shopper-sentiment-analysis_Page_Content">
        <path
          className="shopper-sentiment-analysis_st3"
          d="M86.2 92.5c-2 0-3.7-1.7-3.7-3.7V72.3c0-2 1.7-3.7 3.7-3.7h178.6c2 0 3.7 1.7 3.7 3.7v16.6c0 2-1.7 3.7-3.7 3.7H86.2z"
        />
        <path
          className="shopper-sentiment-analysis_st4"
          d="M264.8 69c1.8 0 3.2 1.4 3.2 3.2v16.6c0 1.8-1.4 3.2-3.2 3.2H86.2c-1.8 0-3.2-1.4-3.2-3.2V72.3c0-1.8 1.4-3.2 3.2-3.2h178.6m0-1.1H86.2c-2.3 0-4.2 1.9-4.2 4.2v16.6c0 2.3 1.9 4.2 4.2 4.2h178.6c2.3 0 4.2-1.9 4.2-4.2V72.3c0-2.4-1.9-4.3-4.2-4.3z"
        />
        <path className="shopper-sentiment-analysis_st5" d="M92.3 75.8H176v8.6H92.3z" />
        <path
          className="shopper-sentiment-analysis_st6"
          d="M295 93h-22c-2.2 0-4-1.8-4-4V72c0-2.2 1.8-4 4-4h22c2.2 0 4 1.8 4 4v17c0 2.2-1.8 4-4 4z"
        />
        <path
          className="shopper-sentiment-analysis_st7"
          d="M326.8 83l-1.6-.9c.2-.9.2-1.8 0-2.6l1.6-.9c.2-.1.3-.3.2-.5-.4-1.3-1.1-2.5-2.1-3.6-.1-.2-.4-.2-.6-.1l-1.6.9c-.7-.6-1.4-1-2.3-1.3v-1.8c0-.2-.1-.4-.4-.4-1.4-.3-2.8-.3-4.1 0-.2 0-.4.2-.4.4V74c-.8.3-1.6.7-2.3 1.3l-1.6-.9c-.2-.1-.4-.1-.6.1-.9 1-1.6 2.2-2.1 3.6-.1.2 0 .4.2.5l1.6.9c-.2.9-.2 1.8 0 2.6l-1.6.9c-.2.1-.3.3-.2.5.4 1.3 1.1 2.5 2.1 3.6.1.2.4.2.6.1l1.6-.9c.7.6 1.4 1 2.3 1.3v1.8c0 .2.1.4.4.4 1.4.3 2.8.3 4.1 0 .2 0 .4-.2.4-.4v-1.8c.8-.3 1.6-.7 2.3-1.3l1.6.9c.2.1.4.1.6-.1.9-1 1.6-2.2 2.1-3.6.1-.2 0-.4-.2-.5zm-8.7.7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z"
        />
        <path
          className="shopper-sentiment-analysis_st4"
          d="M86 281.5c-1.9 0-3.5-1.6-3.5-3.5V107c0-1.9 1.6-3.5 3.5-3.5h428.1c1.9 0 3.5 1.6 3.5 3.5v171c0 1.9-1.6 3.5-3.5 3.5H86z"
        />
        <path
          className="shopper-sentiment-analysis_st4"
          d="M514.1 104c1.7 0 3 1.3 3 3v171c0 1.7-1.3 3-3 3H86c-1.7 0-3-1.3-3-3V107c0-1.7 1.3-3 3-3h428.1m0-1H86c-2.2 0-4 1.8-4 4v171c0 2.2 1.8 4 4 4h428.1c2.2 0 4-1.8 4-4V107c0-2.2-1.8-4-4-4z"
        />
        <path className="shopper-sentiment-analysis_st5" d="M92.3 111.7H157v8.6H92.3z" />
        <path className="shopper-sentiment-analysis_st7" d="M90.8 130.2H156V274H90.8z" />
        <path className="shopper-sentiment-analysis_st8" d="M205 134h51v4h-51z" />
        <path className="shopper-sentiment-analysis_st5" d="M205 138h8.4v4H205z" />
        <path className="shopper-sentiment-analysis_st6" d="M205 130h233v4H205z" />
        <path className="shopper-sentiment-analysis_st5" d="M178 131.7h19v8.6h-19z" />
        <path className="shopper-sentiment-analysis_st8" d="M205 150h59v4h-59z" />
        <path className="shopper-sentiment-analysis_st5" d="M205 154h4v4h-4z" />
        <path className="shopper-sentiment-analysis_st6" d="M205 146h206v4H205z" />
        <path className="shopper-sentiment-analysis_st5" d="M174 147.7h23v8.6h-23z" />
        <path className="shopper-sentiment-analysis_st8" d="M205 166h40v4h-40z" />
        <path className="shopper-sentiment-analysis_st5" d="M205 170h6v4h-6z" />
        <path className="shopper-sentiment-analysis_st6" d="M205 162h237v4H205z" />
        <path className="shopper-sentiment-analysis_st5" d="M173 163.7h24v8.6h-24z" />
        <path className="shopper-sentiment-analysis_st8" d="M205 182h71v4h-71z" />
        <path className="shopper-sentiment-analysis_st5" d="M205 186h2v4h-2z" />
        <path className="shopper-sentiment-analysis_st6" d="M205 178h233v4H205z" />
        <path className="shopper-sentiment-analysis_st5" d="M176 179.7h21v8.6h-21z" />
        <path className="shopper-sentiment-analysis_st8" d="M205 198h31v4h-31z" />
        <path className="shopper-sentiment-analysis_st5" d="M205 202h13v4h-13z" />
        <path className="shopper-sentiment-analysis_st6" d="M205 194h213v4H205z" />
        <path className="shopper-sentiment-analysis_st5" d="M173 195.7h24v8.6h-24z" />
        <path className="shopper-sentiment-analysis_st8" d="M205 214h22v4h-22z" />
        <path className="shopper-sentiment-analysis_st5" d="M205 218h1v4h-1z" />
        <path className="shopper-sentiment-analysis_st6" d="M205 210h265v4H205z" />
        <path className="shopper-sentiment-analysis_st5" d="M168 211.7h29v8.6h-29z" />
        <path className="shopper-sentiment-analysis_st8" d="M205 230h59v4h-59z" />
        <path className="shopper-sentiment-analysis_st5" d="M205 234h3v4h-3z" />
        <path className="shopper-sentiment-analysis_st6" d="M205 226h249v4H205z" />
        <path className="shopper-sentiment-analysis_st5" d="M173 227.7h24v8.6h-24z" />
        <path className="shopper-sentiment-analysis_st8" d="M205 246h51v4h-51z" />
        <path className="shopper-sentiment-analysis_st5" d="M205 250h2v4h-2z" />
        <path className="shopper-sentiment-analysis_st6" d="M205 242h202v4H205z" />
        <path
          className="shopper-sentiment-analysis_st5"
          d="M170 243.7h27v8.6h-27zM294 265.7h19v8.6h-19zM321 265.7h19v8.6h-19zM348 265.7h19v8.6h-19z"
        />
        <path
          className="shopper-sentiment-analysis_st3"
          d="M94.3 135.7H136v8.6H94.3zM94.3 149.7H141v8.6H94.3zM94.3 163.7H148v6.3H94.3zM94.3 173.7H143v6.3H94.3zM94.3 183.7H148v6.3H94.3zM94.3 193.7H146v6.3H94.3zM94.3 203.7H127v6.3H94.3z"
        />
      </g>
    </svg>
  )
}

export default ShopperSentimentAnalysis
